import script from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseLayout.vue?vue&type=script&setup=true&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=9f58697a&lang=css"

const __exports__ = script;

export default __exports__